import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './facebookLiveFeed.css';
import * as FBLiveActions from './FacebookLiveActions';
import { fetchInitialData2 } from "../fetchData";
import Service from '../service/Service';
import ShareOptions from './ShareOptions';
import CountDownTimer from './CountDownTimer';
import withContext from "../../withContext";

const service = new Service();

class SessionDetails extends Component {
    constructor(props) {
        super(props);
        let sessionDetailsData = [];
        let sessionsLinedupData = [];
        let commentList = [];
        let serverSideData = [];
        let sessLinedupCount = '';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData:::", serverSideData)
        if(serverSideData){
            if(serverSideData['data1'] && serverSideData['data1']['msg'] == "1" && serverSideData['data1']['result'] && serverSideData['data1']['result'][0]){
                sessionDetailsData = serverSideData['data1']['result'][0];
                commentList = serverSideData['data1']['result'][0]['comment'];
            }
            if(serverSideData['data2'] && serverSideData['data2']['msg'] == "1" && serverSideData['data2']['result']){
                sessLinedupCount = serverSideData['data2']['result'].length;
                for(let i = 0; i < serverSideData['data2']['result'].length; i++) {
                    if(i < 3){
                        sessionsLinedupData[i] = serverSideData['data2']['result'][i];
                    }
                }
            }
        }
        console.log("sessionDetailsData:::", sessionDetailsData);
        console.log("sessionsLinedupData:::", sessionsLinedupData);
        if (this.props.location.search.includes('from=app')) {
           var isApp=true;
        }else{
           var isApp=false;
        }
        this.state = {
            sessionDetailsData : sessionDetailsData,
            sessionLinedupData : sessionsLinedupData,
            commentList : commentList,
            chars_left : 255,
            commentCount : sessionDetailsData.commentCount,
            sessLinedupCount : sessLinedupCount,
            isApp:isApp
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookie) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }

        let videoid = reqUrl.split('/')[3];
        let obj1 = {
            url: global.api_url + "fb/livedetailpage",
            body: JSON.stringify({
                "videoid": videoid
            })
        };
        let obj2 = {
            url: global.api_url + "fb/getSessionlinedup",
            body: JSON.stringify({
                "pageno":"1",
 	            "pagesize":"1000"
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        // debugger;
        document.addEventListener("click", FBLiveActions.domClick);
        var videoid = (window.location.pathname).split("/")[3];
        this.setState({ videoID: videoid });
        if (navigator.onLine) {
            if (!this.state.sessionDetailsData || (this.state.sessionDetailsData && this.state.sessionDetailsData.length < 1)) {
                service.showLoader();
                this.getsessionDetData(videoid);
            } else {
                localStorage.setItem('sessionDetailsData', JSON.stringify(this.state.sessionDetailsData));
                localStorage.setItem('commentList', JSON.stringify(this.state.commentList));
            }
            if (!this.state.sessionLinedupData || (this.state.sessionLinedupData && this.state.sessionLinedupData.length < 1)) {
                service.showLoader();
                this.getsessionLinedupData('', false);
            } else {
                var sessLinedup = [];
                for(let i = 0; i < this.state.sessionLinedupData.length; i++) {
                    if(i < 3){
                        sessLinedup[i] = this.state.sessionLinedupData[i];
                    }
                }
                localStorage.setItem('sessionLinedupData', JSON.stringify(sessLinedup));
            }
        } else {
            if (localStorage.getItem('sessionDetailsData')) {
                this.setState({ 
                    sessionDetailsData: JSON.parse(localStorage.getItem('sessionDetailsData')),
                    commentList: JSON.parse(localStorage.getItem('commentList'))
                });
            }
            if (localStorage.getItem('sessionLinedupData')) {
                var data = JSON.parse(localStorage.getItem('sessionLinedupData'));
                var sessLinedup = [];
                for(let i = 0; i < data.length; i++) {
                    if(i < 3){
                        sessLinedup[i] = data[i];
                    }
                }
                this.setState({ sessionLinedupData: sessLinedup});
            }
            service.hideLoader();
        }
    }

    getsessionDetData(videoid){
        // debugger;
        var url = global.api_ci_url + "FacebookLiveFeed/getsessionDetData";
        let postdata = {
            "videoid" : videoid
        };
        service.postServiceCall(url, postdata).then((json) => {
            if (json['msg'] == "1") {
                console.log("sessionDetailsData -- ",json['result'][0]);
                this.setState({ 
                    sessionDetailsData : json['result'][0],
                    commentList : json['result'][0]['comment'],
                    commentCount : json['result'][0]['commentCount']
                });
                localStorage.setItem('sessionDetailsData', JSON.stringify(json['result'][0]));
                localStorage.setItem('commentList', JSON.stringify(json['result'][0]['comment']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    getsessionLinedupData(e, getmore){
        var url = global.api_ci_url + "FacebookLiveFeed/getsessionLinedupData";
        let postdata = {
            "pageno":"1",
 	        "pagesize":"1000"
        };
        if(getmore == true){
            var _this = e.currentTarget;
        }
        service.postServiceCall(url, postdata).then((json) => {
            // debugger;
            if (json['msg'] == "1") {
                var sessLinedup = [];
                if(getmore == true){
                    sessLinedup = json['result'];
                    _this.style.display = "none";
                }else{
                    this.setState({sessLinedupCount : json['result'].length});
                    for(let i = 0; i < json['result'].length; i++) {
                        if(i < 3){
                            sessLinedup[i] = json['result'][i];
                        }
                    }
                }
                this.setState({ sessionLinedupData : sessLinedup });
                localStorage.setItem('sessionLinedupData', JSON.stringify(sessLinedup));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    getcommentData(videoid){
        // debugger;
        var url = global.api_ci_url + "FacebookLiveFeed/getsessionDetData";
        let postdata = {
            "videoid" : videoid
        };
        service.postServiceCall(url, postdata).then((json) => {
            if (json['msg'] == "1") {
                console.log("sessionDetailsData --- ",json['result'][0]);
                // let commentData = this.state.sessionDetailsData;
                this.setState({ commentList : json['result'][0]['comment'], commentCount : json['result'][0]['commentCount'] });
                localStorage.setItem('commentList', JSON.stringify(json['result'][0]['comment']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    handleCharCount(event) {
        // debugger;
        var input = event.target.value;
        var charCount = 255 - input.length;
        this.setState({
            chars_left: charCount
        });
    }

   


    joinSession(){
        if (navigator.onLine) {
            if (this.state.isApp) {
                FBLiveActions.loginCallBack();
            } else {
                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                return false;
            }
        } else {
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }

    render() {
        var sessionDet = this.state.sessionDetailsData;
        return (
            <main className="facebookLive main-container">
                <Helmet
                    title='Live Expert Sessions, Seminars and Workshops | FirstCry Parenting'
                    meta={[
                        { "name": "description", "content": "Watch live expert sessions on parenting, pregnancy, breastfeeding, child development, care, food, nutrition, and safety tips. Please register and stay tuned." },
                        { "name": "keywords", "content": "Live Expert Sessions" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/live-sessions/")} className="R11_9e">Expert Sessions</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Live Expert Session on {sessionDet.videoTitle}</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Live Expert Session on {sessionDet.videoTitle}</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {sessionDet && sessionDet != '' ?
                        <div className="session-details-main">
                        
                        <div id="fb-root"></div>
                        <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v8.0&appId=296881491736046&autoLogAppEvents=1" nonce="ml0EF60P"></script>
                        {sessionDet && sessionDet.isLogin && !sessionDet.showTimer && !sessionDet.showBanner ?
                            <div className="after-live">
                                <div className="live-video">
                                    <div className="fb-video" data-href={`https://www.facebook.com/facebook/videos/${this.state.videoID}`} data-show-text="false" data-width="728" data-height="408">
                                        <blockquote cite={`https://developers.facebook.com/FirstCryParenting/videos/${this.state.videoID}`} className="fb-xfbml-parse-ignore">
                                            <a href={`https://developers.facebook.com/FirstCryParenting/videos/${this.state.videoID}`}></a>
                                        </blockquote>
                                    </div>
                                    <div className="bg-sheen" style={{"display":"none"}}></div>
                                </div>
                                {/*<div className="show-live">
                                    <div className="left M17_white live-icon">LIVE</div>
                                    <div className="left live-count M17_white">
                                        <div data-icon-font="$" className="">15</div>
                                    </div>
                                </div>*/ }
                                {/* <div className="full-screen">
                                    <div className="full"><img src={"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/fullScreen1.png"} /></div>
                                    <div className="full not-full"><img src={"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/smallScreen2.png"} /></div>
                                    <div className="seek-bar">
                                        <div className="seekbar-inner"></div>
                                    </div>
                                </div> */}
                                <div className="social-media-cnt">
                                    <div className="likes-section left">
                                        <span className={sessionDet.isLike ? "likeicon liked" : "likeicon"} data-icon-font="T" onClick={() => FBLiveActions.likeVideo(sessionDet.likeCount, this.state.videoID)}></span>
                                        <span className="M15_42 likecount">{sessionDet.likeCount} Likes</span>
                                    </div>
                                    <div className="views-section left">
                                        <span className="likeicon" data-icon-font="$"></span>
                                        <span className="M15_42">{sessionDet.view_count} Views</span>
                                    </div>
                                    <div className="share-section right" id={`share_${this.state.videoID}`} onClick={() => FBLiveActions.shareOn(this.state.videoID,this.state.isApp,sessionDet.bannerUrl,sessionDet.videoTitle,sessionDet.description)}>
                                        <span className="fb-icon">
                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png"
                                            alt="Facebook" title="Facebook" />
                                        </span>
                                        <span className="whtap-icon" data-icon-font="&#xe019;"></span>
                                        <span className="M15_42 share-in">Share</span>
                                        <ShareOptions data={sessionDet} eleRef={this}/>
                                    </div>
                                </div>
                            </div> 
                            :
                            sessionDet && sessionDet.showBanner ?
                            <div className="session-banner">
                                <img src={sessionDet.bannerUrl.replace("http://", "https://")} />
                            </div>
                            :
                            sessionDet && sessionDet.showTimer ?
                            <div className="before-live">
                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/main-screen-img.jpg" />
                                <CountDownTimer parent={this} videoID={this.state.videoID} sessionDate={sessionDet.sessionDate} />
                            </div> : null
                        }
                            <div className="share-overlay"></div>
                            <div className="session-details-cnt">
                                <div className="session-details">
                                    <div className="M16_42 session-topic">
                                        Topic: {sessionDet.videoTitle}
                                    </div>
                                    <div className="M13_42">
                                        Expert: <span className="R13_61">{sessionDet.expertName}</span>
                                    </div>
                                    <div className="M13_42 session-date">
                                        Date: <span className="R13_61">{FBLiveActions.getSessionDate(sessionDet.sessionDate, "datetime")}</span>
                                    </div>
                                    <div className="M13_42">
                                        Description: <span className="R13_61">{sessionDet.description}</span>
                                    </div>
                                </div>
                                {!sessionDet.isLogin &&
                                <div><div className="M14_white join-btn" onClick={() => this.joinSession()}>JOIN NOW</div>
                                <hr className="hr-line"></hr></div>
                                }
                                <div className="M16_42">{this.state.commentCount} Comment(s)</div>
                                <textarea className="comment-here" onChange={this.handleCharCount.bind(this)} maxLength="255"></textarea>
                                <div className="charcount">{this.state.chars_left} characters remaining</div>
                                <div className="M14_white post-btn" onClick={() => FBLiveActions.postComment(this.state.videoID, this)}>POST</div>
                                {this.state.commentList && this.state.commentList.length > 0 &&
                                <div className="comments-list">
                                    {this.state.commentList.map((comments, index) => 
                                    <div key={index} className="user-comments">
                                        <div className="user-icon left">
                                        {comments.profilePhoto ?
                                            <img src={comments.profilePhoto.replace("http://", "https://")}/> :
                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png" alt="Default Profile Icon" title="Default Profile Icon"/>
                                        }
                                        </div>
                                        <div className="usercomment">
                                            <div className="user-name M16_42">{comments.userName}</div>
                                            <div className="comment R15_61">{comments.comment}</div>
                                        </div>
                                    </div>
                                    )}
                                    {this.state.commentCount > 3 &&
                                    <div className="M14_42 readmorebtn load-cmts" onClick={() => FBLiveActions.getMoreComments(this.state.videoID, this)}>LOAD MORE COMMENTS</div>
                                    }
                                </div>
                                }
                            </div>
                        
                            {this.state.sessionLinedupData && this.state.sessionLinedupData.length > 0 &&
                            <div className="sessions-linedup-cnt">
                                <div className="sessions-linedup">
                                    <div className="title B16_42">SESSIONS LINED-UP</div>
                                    {this.state.sessionLinedupData && this.state.sessionLinedupData.map((sessionlinedup, index) => 
                                    <div key={index} className="sessions">
                                        <div className="sessiondate left">
                                            <div className="M22_42">{FBLiveActions.getSessionDate(sessionlinedup.sessionDate, "onlydate")}</div>
                                            <div className="R14_9e">{FBLiveActions.getSessionDate(sessionlinedup.sessionDate, "onlymonth")}</div>
                                        </div>
                                        <div className="sessiondet">
                                            <div className="sessiontopic M16_42">{sessionlinedup.videoTitle}</div>
                                            <div className="R13_61 expertdecp">For {sessionlinedup.ageGroupFor}-{sessionlinedup.ageGroupTo} years | Live Sessions By {sessionlinedup.expertName}</div>
                                            <div className="R12_9e">Starts at {FBLiveActions.getSessionDate(sessionlinedup.sessionDate, "onlytime")}</div>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                {this.state.sessLinedupCount && this.state.sessLinedupCount > 3 && 
                                <div className="M14_fc88af readmorebtn" onClick={(e) => this.getsessionLinedupData(e, true)}>READ MORE</div>
                                }
                            </div>
                            }
                        </div> : 
                        <div className="noSession">Session expired or something went wrong</div>
                        }
                        <div className="alertMsg-overlay fblivemsg-overlay"><div className="alert-popup"><span className="alertmsg fblivemsg"></span></div></div>
                    </div>
                </div>
            </main>
        )
    }
}

export default withContext(SessionDetails);
